import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-se",
  "use": "icon-flag-se-usage",
  "viewBox": "0 0 1568 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1568 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-se\"><defs><style type=\"text/css\"></style></defs><path d=\"M1555.872 0v1024H0V0z\" fill=\"#0B5089\" p-id=\"7689\" /><path d=\"M629.632 399.84V0H405.984v399.84H0v224.32h405.984V1024h223.648V624.16h926.24V399.84z\" fill=\"#FFC100\" p-id=\"7690\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-se.svg
// module id = Mvad
// module chunks = 24